import React from 'react';

const SectionTitle = (props) => {
  return (
    <div className = {props.withText==="false" ? "SectionTitle wrap-title margin-title-noText" : "SectionTitle wrap-title"}>
            
      <h3 className = {props.type === "center" ? "textAlign-center" : ""}>{props.text}</h3>

    </div>
  );
}

export default SectionTitle;